import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

const COLORS = {
  DRAFT: "default",
  ORDERED: "info",
  PARTIALLY_RECEIVED: "warning",
  RECEIVED: "success",
  CANCELLED: "error",
};

export default function PurchaseOrderStatusChip({ status }) {
  const { t } = useTranslation();
  const normalized = String(status || "").toUpperCase();
  return (
    <Chip
      size="small"
      color={COLORS[normalized] || "default"}
      label={t(`purchaseOrders.status.${normalized}`, { defaultValue: normalized })}
      sx={{ fontWeight: 800 }}
    />
  );
}
